<template>
  <section class="overflow-hidden">
    <div class="xl:py-24 py-16">
      <div class="container">
        <div class="text-center">
          <h1 class="text-3xl/tight font-medium mt-3 mb-4">
            {{ featureStore.featureHeadline }}
          </h1>
          <p class="text-gray-500">
            {{ featureStore.featureDescription }}
          </p>
        </div>

        <div
          class="grid lg:grid-cols-2 grid-cols-1n gap-6 items-center p-10"
          v-for="(feature, index) in featureStore.features.filter(
            (f) => f.Type === 'main'
          )"
          :key="index"
        >
          <landing-feature-main-single-feature
            :feature="feature"
            :index="index"
          />
        </div>
      </div>
    </div>

    <div class="xl:py-24 py-16">
      <div class="container" data-aos="fade-up" data-aos-duration="600">
        <div class="text-center">
          <h1 class="text-2xl font-medium">
            {{ featureStore.featureSecondHeadline }}
          </h1>
        </div>

        <div class="py-16">
          <div class="grid xl:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-5">
            <div :class="`order-${i} xl:order-${i}`" v-for="i in 4" :key="i">
              <landing-features-single-feature
                v-for="(feature, index) in featureStore.features.filter(
                  (f) => f.Type === 'side'
                )"
                :key="index"
                :feature-column-change-factor="i - 1"
                :feature-head-line="feature.HeadLine"
                :feature-icon="feature.Icon"
                :feature-index="index"
              />
            </div>
          </div>
        </div>

        <button class="flex items-center justify-center mx-auto">
          <a
            :href="featureStore.featureButtonLink"
            class="bg-primary text-white rounded-lg text-sm font-semibold flex-none hover:shadow-lg hover:shadow-primary/30 focus:shadow-none focus:outline focus:outline-primary/40 px-6 py-3"
          >
            {{ featureStore.featureButtonText }}
            <i class="fa-solid fa-arrow-right ms-2"></i>
          </a>
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useFeatureStore } from "@/stores/featureStore";
import LandingFeaturesSingleFeature from "@/components/LandingLayout/landing-compoments/LandingFeaturesSingleFeature.vue";
import LandingFeatureMainSingleFeature from "@/components/LandingLayout/landing-compoments/LandingFeatureMainSingleFeature.vue";

const featureStore = useFeatureStore();
</script>
